import { WizardState } from '../wizardModel';
import { CampaignFormValues } from '../wizardSubmission';
import { AdapterContext } from './common';
import { gameValues } from './game';
import { instantRewardValues } from './instantReward';
import { progressValues } from './progress';
import { questValues } from './quest';
import { stampValues } from './stamp';

type TypeAdapter = (state: WizardState, context: AdapterContext) => CampaignFormValues;

const ADAPTERS: Record<NonNullable<WizardState['type']>, TypeAdapter> = {
  stamp: stampValues,
  quest: questValues,
  progress: progressValues,
  game: gameValues,
  instant_outcome: instantRewardValues
};

/** The wizard's answers as the `campaign_form` values the module's create path takes. */
export const buildCampaignValues = (
  state: WizardState,
  context: AdapterContext
): CampaignFormValues => ADAPTERS[state.type ?? 'stamp'](state, context);
